"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as t } from "react/jsx-runtime";
import o from "classnames";
import { getPrefixedDataAttributes as f } from "./utils/dom.js";
import { backgroundVariant as v, desktopContainer as p, forcedMarginDesktopContainer as y, mobileContainer as h, forcedMarginMobileContainer as C, responsiveLayoutContainer as L, fullWidth as b, responsiveLayout as R, resetContainerMobile as V, resetContainerDesktop as g, resetMobile as M, resetDesktop as N } from "./responsive-layout.css-mistica.js";
import { useThemeVariant as x, ThemeVariant as D } from "./theme-variant-context.js";
const k = (param)=>{
    let { children: a, isInverse: e = !1, variant: r, backgroundColor: s, className: d, fullWidth: i, dataAttributes: m, shouldExpandWhenNested: l = !1, innerDivClassName: c } = param;
    const u = x(), n = r || e && "inverse" || void 0;
    return /* @__PURE__ */ t(D, {
        variant: n !== null && n !== void 0 ? n : u,
        children: /* @__PURE__ */ t("div", _object_spread_props(_object_spread({
            className: o(d, n && n !== "default" && v[n], ...i ? [] : [
                l ? p : y,
                l === !0 ? h : C,
                L
            ]),
            style: s ? {
                background: s
            } : void 0
        }, f(m)), {
            children: /* @__PURE__ */ t("div", {
                className: o(i ? b : R, c),
                children: a
            })
        }))
    });
}, T = (_param)=>{
    var { children: a } = _param, e = _object_without_properties(_param, [
        "children"
    ]);
    return /* @__PURE__ */ t(k, _object_spread_props(_object_spread({}, e), {
        shouldExpandWhenNested: !0,
        children: a
    }));
}, q = (param)=>{
    let { children: a, skipMobile: e = !1, skipDesktop: r = !1 } = param;
    return /* @__PURE__ */ t("div", {
        className: o({
            [V]: !e,
            [g]: !r
        }),
        children: /* @__PURE__ */ t("div", {
            className: o({
                [M]: !e,
                [N]: !r
            }),
            children: a
        })
    });
}, w = T;
export { k as InternalResponsiveLayout, q as ResetResponsiveLayout, w as default };
